import React from 'react'
import Services from './Service'
import HeroSection from './HeroSection'
import Stats from './Stats'
import Review from './Review'


function HomePage() {
  return (
    <div>
      <HeroSection />
      <Services />
      <Stats />
      <Review />
    </div>
  )
}

export default HomePage
